import React, { useState, useMemo } from 'react';
import { transformRandoxSlots, RandoxSlots, groupSlotsByWeekSorted, parseRandoxClinicSlotUtc } from './helpers';
import { ClinicSlotSurveyData } from '../CustomSurvey/customWidgets/Randox/RandoxSearchInput';
import { RandoxSlot } from '../../types';
import { F2FSlotGrid } from '../BookAppointment/F2FSlotGrid';

const DisplayAvailableSlotsRandox = ({
  location,
  selectedId,
  setSelectedSlot
}: {
  location: RandoxSlots[0];
  selectedId: string;
  setSelectedSlot: (slot: ClinicSlotSurveyData) => void;
}) => {
  const [currentWeek, setCurrentWeek] = useState(0);

  const tranformedSlots = useMemo(() => transformRandoxSlots(location?.clinicSlots), [location?.clinicSlots]);
  const slotsByWeek = Object.values(groupSlotsByWeekSorted(tranformedSlots));
  const currentWeekSlots = slotsByWeek[currentWeek];

  const handleSelectSlot = (selectedSlot: RandoxSlot) => {
    const timeSlotInfo = location.clinicSlots.find((slot) => slot.id === selectedSlot.slotId);
    const surveySlotData: ClinicSlotSurveyData = {
      id: location.Id,
      name: location.Name,
      postcode: location.postalCode,
      addressLine1: location.addressLine1,
      addressLine2: location.addressLine2,
      city: location.townCity,
      distance: location.distanceInMiles,
      slotId: timeSlotInfo?.id || '',
      date: timeSlotInfo?.date || '',
      time: timeSlotInfo?.time || ''
    };

    try {
      surveySlotData.displayTime = parseRandoxClinicSlotUtc(surveySlotData.date, surveySlotData.time)
        .setZone('local')
        .toFormat("cccc, d MMMM yyyy 'at' h:mm a");
    } catch {
      surveySlotData.displayTime = `${surveySlotData.date} ${surveySlotData.time}`;
    }

    setSelectedSlot(surveySlotData);
  };

  return (
    <F2FSlotGrid
      clinician={location}
      weekCount={currentWeek}
      maxWeekCount={slotsByWeek?.length - 1}
      setWeekCount={setCurrentWeek}
      slots={currentWeekSlots}
      selectedId={selectedId}
      selectSlot={handleSelectSlot}
      mobileView
      slotTooltipUtc
    />
  );
};

export default DisplayAvailableSlotsRandox;
